import { render, staticRenderFns } from "./CookieAlert.vue?vue&type=template&id=53742d27&scoped=true"
import script from "./CookieAlert.vue?vue&type=script&lang=js"
export * from "./CookieAlert.vue?vue&type=script&lang=js"
import style0 from "./CookieAlert.vue?vue&type=style&index=0&id=53742d27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53742d27",
  null
  
)

export default component.exports